import { inject, ref, watch } from 'vue';
import { defineStore } from 'pinia';
import { useRouter } from 'vue-router';

export const useStoreModal = defineStore('modal', () => {
    const isOpen = ref(false);
    const type = ref(null);
    const context = ref(null);
    let animation = ref({ name: 'fade' });
    let closeButton = ref(true);

    const router = useRouter();

    function open(_type, _context, animate = { name: 'fade' }) {
        if (!_type) {
            throw new Error('Type is required');
        }

        if (!_context) {
            throw new Error('Context is required');
        }


        if (animate) {
            animation.value = animate;
        }

        // add router query params with modal params in order to be able to use browser back button
        let query = router.currentRoute.value.query;
        query = { ...query, "modal": true, "modal_type": _type };
        router.push({ query });

        closeButton.value = false;
        context.value = _context;
        type.value = _type;
        isOpen.value = true;
    }

    // controllo dal router se il query params modal non è più presente allora chiudo la modal
    watch(router.currentRoute, (to, from) => {
        if (to.query.modal === undefined) {
            close(false);
        }
    });

    function close(payload = true) {
        // remove query params
        if (router.currentRoute.value.query.modal) {
            let query = JSON.parse(JSON.stringify(router.currentRoute.value.query));
            // remove only the modal query params
            Object.keys(query).forEach(key => {
                if (key.startsWith('modal')) {
                    delete query[key];
                }
            });
            router.back();
        }

        if (context.value && context.value['callback'] && typeof context.value['callback'] === 'function') {
            context.value['callback'](payload);
        }

        
        type.value = null;
        context.value = null;
        setTimeout(() => {
            isOpen.value = false;
            animation.value = { name: 'fade' };
        }, 300);
    }

    function toggleCloseButton(value = null) {
        if (value === null) {
            closeButton.value = !closeButton.value;
        } else {
            closeButton.value = value;
        }
    }

    return {
        isOpen,
        type,
        context,
        animation,
        closeButton,
        open,
        close,
        toggleCloseButton,
    };
});